import { ApiService } from '@services/api/api-base.service'
import { SortDirection } from '@app/directives/sortable-header.directive'
import { UserSearch } from '@models/user.model'
import { environment } from '@env/environment'

export class AuthenticateApiBaseService extends ApiService<UserSearch> {
	override get url(): string {
		return environment.url_authentication_api
	}

	override sortDirection: { [key: string]: SortDirection } = {}
}
